module.exports = __webpack_public_path__ + "img/user_list_big_bg.56311cc7.png";